var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"captcha-element"}}),_c('button',{staticStyle:{"display":"none"},attrs:{"id":"captcha-button"}},[_vm._v("验证")])])
}]

export { render, staticRenderFns }